export default "__VITE_ASSET__c9487a6e__"